import React from 'react';
var YoutubeInfo = function (_a) {
    var subscriberCount = _a.subscriberCount, videoCount = _a.videoCount, viewCount = _a.viewCount;
    return (React.createElement("div", { className: 'youtube-info' },
        React.createElement("div", { className: 'youtube-info__data' },
            React.createElement("span", { className: 'youtube-info__number' }, Number(videoCount).toLocaleString()),
            " Uploads"),
        React.createElement("div", { className: 'youtube-info__data' },
            React.createElement("span", { className: 'youtube-info__number' }, Number(subscriberCount).toLocaleString()),
            " Subscribers"),
        React.createElement("div", { className: 'youtube-info__data' },
            React.createElement("span", { className: 'youtube-info__number' }, Number(viewCount).toLocaleString()),
            " Total views")));
};
export default YoutubeInfo;
